


























import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'
import { SortOrder } from '@/types'
import { IconBibliography } from '@/components/molecules/IconBibliography'

export interface UserNewArrivalNoticeMagazineTableItem {
  id: number
  displayTitle: string
}

@Component({
  components: {
    IconBibliography,
    DataTable
  }
})
export default class UserNewArrivalNoticeMagazineTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  items!: UserNewArrivalNoticeMagazineTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return [
      {
        width: 40,
        items: [
          {
            name: 'descNo',
            align: 'right'
          }
        ]
      },
      {
        width: '100',
        items: [
          {
            name: 'displayTitle',
            headerText: 'タイトル',
            sortable: true,
            sortOrder: ''
          }
        ]
      }
    ]
  }

  get sortedInputItems(): UserNewArrivalNoticeMagazineTableItem[] {
    if (this.sortName) {
      return orderBy<UserNewArrivalNoticeMagazineTableItem>(
        this.items,
        (item: UserNewArrivalNoticeMagazineTableItem) =>
          item[this.sortName as keyof UserNewArrivalNoticeMagazineTableItem],
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
